<svg
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-linecap="round"
  stroke-linejoin="round"
  aria-hidden="true"
  focusable="false"
  [attr.width]="size"
  [attr.height]="size"
  [attr.stroke-width]="strokeWidth"
>
  @switch (name) {
    @case ('alert-circle') {
      <svg:circle cx="12" cy="12" r="10" />
      <svg:path d="M12 8v4M12 16h.01" />
    }
    @case ('bell') {
      <svg:path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
      <svg:path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
    }
    @case ('briefcase') {
      <svg:rect x="2" y="7" width="20" height="14" rx="2" />
      <svg:path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    }
    @case ('check') {
      <svg:path d="M20 6L9 17l-5-5" />
    }
    @case ('chevron-down') {
      <svg:path d="M6 9l6 6 6-6" />
    }
    @case ('chevron-left') {
      <svg:path d="M15 18l-6-6 6-6" />
    }
    @case ('chevron-right') {
      <svg:path d="M9 18l6-6-6-6" />
    }
    @case ('clock') {
      <svg:circle cx="12" cy="12" r="10" />
      <svg:path d="M12 6v6l4 2" />
    }
    @case ('eye') {
      <svg:path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
      <svg:circle cx="12" cy="12" r="3" />
    }
    @case ('eye-off') {
      <svg:path d="M9.9 4.2A10 10 0 0 1 12 4c6.5 0 10 8 10 8a17 17 0 0 1-2.2 3.2M6.6 6.6A17 17 0 0 0 2 12s3.5 7 10 7a9.7 9.7 0 0 0 5.4-1.6" />
      <svg:path d="M14.1 14.1a3 3 0 1 1-4.2-4.2" />
      <svg:path d="M2 2l20 20" />
    }
    @case ('file-text') {
      <svg:path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <svg:path d="M14 2v6h6M9 13h6M9 17h4" />
    }
    @case ('globe') {
      <svg:circle cx="12" cy="12" r="10" />
      <svg:path d="M2 12h20" />
      <svg:path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    }
    @case ('lock') {
      <svg:rect x="3" y="11" width="18" height="11" rx="2" />
      <svg:path d="M7 11V7a5 5 0 0 1 10 0v4" />
    }
    @case ('mail') {
      <svg:rect x="2" y="4" width="20" height="16" rx="2" />
      <svg:path d="M22 7l-10 6L2 7" />
    }
    @case ('map-pin') {
      <svg:path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z" />
      <svg:circle cx="12" cy="10" r="3" />
    }
    @case ('pen') {
      <svg:path d="M12 20h9" />
      <svg:path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" />
    }
    @case ('phone') {
      <svg:path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z" />
    }
    @case ('plus') {
      <svg:path d="M12 5v14M5 12h14" />
    }
    @case ('refresh') {
      <svg:path d="M21 12a9 9 0 1 1-2.6-6.4L21 8" />
      <svg:path d="M21 3v5h-5" />
    }
    @case ('ruler') {
      <svg:path d="M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.4 2.4 0 0 1 0-3.4l2.6-2.6a2.4 2.4 0 0 1 3.4 0z" />
      <svg:path d="M14.5 12.5l2-2M11.5 9.5l2-2M8.5 6.5l2-2M17.5 15.5l2-2" />
    }
    @case ('shield') {
      <svg:path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
    }
    @case ('shield-check') {
      <svg:path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
      <svg:path d="M9 12l2 2 4-4" />
    }
    @case ('smartphone') {
      <svg:rect x="5" y="2" width="14" height="20" rx="2" />
      <svg:path d="M12 18h.01" />
    }
    @case ('x') {
      <svg:path d="M6 6l12 12M18 6L6 18" />
    }
  }
</svg>
